module.exports = __webpack_public_path__ + "img/UpgradeSuccess.3c9a2394.svg";